import util from '@/util';

/**
 * Construct Vuex 'audit' module
 *
 * @param {*} services Services object for API access
 * @return {*}
 */
export default function(services) {
  /**
   * Helper method to construct a filter object with empty settings
   *
   * @return {*} Object representing empty filter
   */
  function emptyFilter() {
    return {
      recordType: null,
      recordIds: null,
      affectedFields: null,
      userIds: null,
      startDate: null,
      endDate: null
    };
  }

  /**
   * Retrieve audit logs from server
   * Gets the latest record set matching pagination and filter settings
   *
   * @param {*} context Vuex module context
   * @return {*|PromiseLike<T>|Promise<T>} Promise containing record set
   */
  function getRecords(context) {
    context.commit('loading', true);
    context.commit('records', []);
    return services.authenticator.get('/auditHistory', {
      params: {
        page: context.state.pagination.page - 1,
        size: context.state.pagination.rowsPerPage,
        recordType: context.state.filter.recordType,
        recordIds: context.state.filter.recordIds,
        userIds: context.state.filter.userIds,
        affectedFields: context.state.filter.affectedFields,
        startDate: util.toUTCTimestamp(context.state.filter.startDate),
        // Make inclusive of end date
        endDate: ((date) =>
          date ? date + 24 * 60 * 60 : null
        )(util.toUTCTimestamp(context.state.filter.endDate))
      }
    }).then((res) => {
      context.commit('records', res.data.data);
      context.commit('totalRecords', res.data.total);
      context.commit('loading', false);
    });
  }

  return {
    namespaced: true,
    state: {
      pagination: {
        page: 1,
        rowsPerPage: Number.parseInt(localStorage.getItem('audit/rowsPerPage')) || 10
      },
      filter: emptyFilter(),
      loading: true,
      records: [],
      totalRecords: 0
    },
    mutations: {
      pagination(state, pagination) {
        state.pagination = pagination;
        localStorage.setItem('audit/rowsPerPage', pagination.rowsPerPage);
      },
      filter(state, filter) {
        state.filter = filter;
      },
      loading(state, loading) {
        state.loading = loading;
      },
      records(state, records) {
        state.records = records;
      },
      totalRecords(state, totalRecords) {
        state.totalRecords = totalRecords;
      }
    },
    actions: {
      setPagination(context, pagination) {
        if (context.state.pagination.page !== pagination.page || context.state.pagination.rowsPerPage !== pagination.rowsPerPage) {
          context.commit('pagination', pagination);
          return getRecords(context);
        }
      },
      setFilter(context, filter) {
        context.commit('filter', filter);
        return getRecords(context);
      },
      reset(context) {
        context.commit('pagination', {
          ...context.state.pagination,
          page: 1
        });
        context.commit('filter', emptyFilter());
        return getRecords(context);
      }
    }
  };
}
